// Каталог строк (ru). Собран из docs/i18n/strings.json.
// Правки вносить там и перезапускать tools/gen-i18n.mjs.

import type { Catalog } from './types.ts';

export const ru: Catalog = {
  action: {
    buy: 'Купить в рассрочку',
    create_offer_instead: 'Выставить свой лот',
    pay: 'Оплатить',
    publish_offer: 'Опубликовать лот',
  },
  admin: {
    add_collection: 'Добавить коллекцию',
    collection_address: 'Адрес коллекции',
    collections: 'Коллекции в реестре',
    contract: 'Контракт',
    deal_code: 'Код новых сделок',
    deal_code_changed: 'Последняя смена',
    deal_code_hint: 'Меняется только для будущих сделок — идущие живут своим кодом, и это единственный способ не менять правила людям посреди выплат.',
    deal_code_never: 'С развёртывания не менялся',
    deals_by_state: 'Сделки',
    fee: 'Комиссия',
    fee_apply: 'Сменить комиссию',
    fee_hint: 'Удерживается с каждого платежа. Потолок 5% зашит в контракт: увод ключа комиссию не поднимет.',
    fee_only_new: 'Новая комиссия действует только на сделки, созданные после смены. Идущие живут своей.',
    handover: 'Передача администрирования',
    handover_accept: 'Принять администрирование',
    handover_address: 'Адрес преемника',
    handover_cancel: 'Отозвать предложение',
    handover_current: 'Сейчас админ',
    handover_hint: 'В два шага: сначала предложение, потом согласие с той стороны. Прямая смена одним сообщением означала бы, что опечатка в адресе оставляет протокол без админа навсегда — ни комиссии, ни реестров, ни вывода собранного.',
    handover_next: 'Предложено',
    handover_none: 'Предложения нет',
    handover_offer: 'Предложить',
    handover_yours: 'Администрирование предложено вам. Пока вы не согласитесь, админ прежний.',
    item_address: 'Адрес любого айтема этой коллекции',
    item_hint: 'Код айтема мастер берёт оттуда: синхронно спросить коллекцию в TON нельзя, поэтому адрес экземпляра он считает сам.',
    layout_detected: 'Раскладка айтема',
    layout_unknown: 'Не удалось определить раскладку айтема: адрес не сошёлся ни с одной из известных. Такую коллекцию вносить нельзя — сделку по ней контракт всё равно не пропустит.',
    master: 'Мастер',
    no_code: 'По этому адресу кода нет — контракт не развёрнут',
    not_admin: 'Этот кошелёк не админ мастера',
    reading_code: 'Читаем код…',
    ref_key: 'Ключ приглашений',
    ref_key_apply: 'Поставить ключ сервера',
    ref_key_hint: 'Сервер подписывает приглашения, контракт проверяет подпись. Ключ обязан совпадать в обоих местах: разойдутся — контракт молча перестанет принимать приглашения, а приложение продолжит их выдавать.',
    ref_key_in_contract: 'В контракте',
    ref_key_match: 'Совпадают',
    ref_key_mismatch: 'Не совпадают — приглашения не работают',
    ref_key_none: 'Не настроен',
    ref_key_off: 'Выключить приглашения',
    ref_key_on_server: 'На сервере',
    registry_empty: 'Пусто — ни одной записи',
    registry_layout: 'раскладка',
    remove: 'Убрать',
    requests_open: 'Открытых офферов',
    retained: 'Удерживается в контрактах',
    stats: 'Сервис',
    subtitle: 'Виден только админскому кошельку мастера. Команды всё равно проверит контракт.',
    title: 'Управление',
    volume: 'Внесено покупателями',
    withdraw: 'Вывод комиссии',
    withdraw_all: 'Всё',
    withdraw_amount: 'Сколько',
    withdraw_available: 'Накоплено',
    withdraw_hint: 'Комиссия копится на самом мастере. Забрать её может только админ и только этой командой — сам мастер переводов не делает.',
    withdraw_send: 'Вывести',
    withdraw_to: 'Куда отправить',
  },
  board: {
    answer_now: 'Ответить условиями',
    asked_this_item: 'Просят именно эту вещь',
    buyers_have_already_named: 'Покупатели назвали свою цену. Сверху — где переплата к флору больше.',
    decline_request: 'Отказаться',
    don_t_wait_buyer: 'Не ждите покупателя — выставите условия сами, и лот попадёт на витрину.',
    empty_state: 'ПУСТО',
    every: 'раз в',
    floor_here: 'НАШ ФЛОР {{floor}}',
    no_requests_other_gifts: 'На остальные ваши NFT офферов пока нет',
    over_floor: 'К ФЛОРУ',
    payments: 'ПЛАТЕЖЕЙ',
    per_payment: 'за платёж',
    per_payment_note: '{{n}} платежей за {{days}}',
    request_expires: 'ОФФЕР ЖИВЁТ ЕЩЁ',
    requests_gifts: 'Офферы на ваши NFT',
    sort_expiry: 'ПО СРОКУ',
    sort_payments: 'КОРОЧЕ ГРАФИК',
    sort_premium: 'ПО СУММЕ',
    total: 'ВСЕГО',
    which_item: 'Какую вещь отдаёте',
    your_answer_hint: 'Покупатель получит уведомление. Пока он не согласился, вы ничем не связаны.',
    your_answer_sent: 'Предложение отправлено',
    your_gift: 'ВАШ NFT',
    your_gifts_count: 'ВАШИХ {{n}}',
    yours_personally: 'ВАМ ЛИЧНО',
  },
  builder: {
    all_on_sale: 'Ваши NFT из этих коллекций выставлены на продажу. Пока лот на площадке, им владеет её контракт, а не вы, — снимите с продажи, и он появится здесь.',
    allowed_collections: 'Что принимается в залог',
    allowed_count: 'Смотреть список · {{count}}',
    allowed_hint: 'Контракт принимает в залог NFT только из этих коллекций. Остальные он отвергнет, и газ за отказ всё равно спишется.',
    already_started: 'По этой вещи лот уже создан',
    already_started_hint: 'Осталось передать её в контракт — до этого покупатели лот не видят. Выставлять второй раз не нужно: это развернёт ещё один контракт и потратит газ впустую.',
    arrives_when_deal_closes: 'придёт одной суммой при закрытии',
    buyer: 'покупателю',
    defer_price: 'Цена переноса',
    defer_price_hint: '{{pct}}% планового платежа — столько покупатель доплатит, чтобы сдвинуть график на период. В счёт долга эти деньги не идут.',
    down_payment: 'ПЕРВЫЙ ВЗНОС',
    flow_locking: 'Передаём NFT',
    flow_timeout: 'Контракт пока не виден',
    flow_timeout_hint: 'Он мог просто задержаться в сети — деньги при этом никуда не делись. Загляните в «Сделки» → «Продавец»: как только контракт появится, там будет кнопка передать NFT.',
    flow_waiting: 'Ждём контракт сделки',
    flow_waiting_hint: 'Сеть разворачивает контракт — обычно это полминуты. Как только он появится, здесь будет кнопка передать NFT.',
    hidden_gifts: 'Ещё {{count}} NFT — из коллекций, которые сюда пока не допущены',
    if_buyer_defaults: 'ЕСЛИ ПОКУПАТЕЛЬ СОРВЁТСЯ',
    later: 'Позже — из «Сделок»',
    live_preview: 'Живой предпросмотр',
    lock_gift: 'Передать NFT в контракт',
    no_gifts: 'На этом кошельке нет NFT',
    no_gifts_in_allowed: 'NFT из этих коллекций у вас нет. Купить их можно на любой площадке — сделка создаётся из того, чем вы уже владеете.',
    none: 'нет',
    not_enough_gas: 'На кошельке {{have}}, а на создание лота нужно {{need}} плюс комиссия сети. Это не плата нам: деньги лягут на контракт сделки и вернутся, когда она закроется. Пополните кошелёк и возвращайтесь.',
    not_owner_now: 'Этим NFT сейчас владеет не ваш кошелёк — похоже, он выставлен на продажу. Снимите его с площадки и вернитесь: сделка уже создана и ждёт залога.',
    on_sale: 'Ещё {{count}} NFT выставлены на продажу — заложить их можно, только сняв с площадки',
    only_whitelisted: 'Показаны только допущенные коллекции: по остальным контракт сделку не создаст, и платить газ за отказ было бы обидно.',
    open_deal: 'Открыть сделку и передать NFT',
    payment_deferrals: 'Переносы платежа',
    payments_weekly: 'ПЛАТЕЖЕЙ · НЕДЕЛЯ',
    per_payment: 'Сразу после взноса — {{upfront}}, дальше по {{each}} с каждого платежа. Остальное держит контракт: из него вернётся доля покупателю, если он сорвётся.',
    pick_gift: 'Что продаём',
    price: 'Цена, {{cur}}',
    price_with_floor: 'Цена, {{cur}} · наш флор {{floor}}',
    publish_hint: 'Проверьте условия: после публикации их уже не изменить — контракт хранит их неизменными.',
    published: 'Лот создан',
    published_hint: 'Осталось передать NFT в контракт — до этого покупатели лот не видят.',
    publishing: 'Публикуем',
    refund_level: 'Уровень компенсации',
    registry_empty: 'Пока не допущена ни одна коллекция — выставить лот не получится.',
    reload_gifts: 'Обновить список',
    step: 'ШАГ',
    steps_collapse: 'Свернуть',
    steps_show_all: 'Показать остальные шаги — {{count}}',
    straight_wallet_2: 'Дойдёт по ходу выплат',
    what_buyer_gets_back: 'Что достанется покупателю при срыве — и что останется вам. Жёстче условия — длиннее льготный период.',
    you: 'ВАМ',
  },
  buyer: {
    always_visible: 'ВСЕГДА НА ВИДУ',
    due: 'К ОПЛАТЕ',
    i_lose: 'ПОТЕРЯЮ',
    if_i_stop_now: 'Если брошу сейчас',
    overdue_grace_period_running: 'ПРОСРОЧКА · ЛЬГОТНЫЙ ПЕРИОД ИДЁТ',
    pay_ahead: 'Вперёд',
    push_payment_week: 'Перенести платёж на неделю',
    received_wallet: 'ПОЛУЧЕНО НА КОШЕЛЁК',
    safe_pay_until: 'Безопасно платить до',
    schedule: 'График',
  },
  confirm: {
    balance_after: 'GRAM · баланс после: {{rest}}',
    balance_unknown: 'GRAM · баланс неизвестен',
    cancel_deal: 'Отменить сделку?',
    cancel_deal_body: 'NFT вернётся вам, лот исчезнет с витрины. Пока первый взнос не внесён, это ничего не стоит.',
    charged_now: 'СПИСАНИЕ СЕЙЧАС',
    claim_gift: 'Забрать NFT?',
    claim_gift_body: 'Сделка закроется окончательно. Покупателю уйдёт компенсация по её условиям, остальное останется вам.',
    defer: 'Перенести платёж?',
    defer_body: 'Весь график сдвинется на один период. Цена переноса в счёт долга не идёт — это отдельная плата.',
    handover: 'Предложить передачу?',
    handover_accept: 'Принять администрирование?',
    handover_accept_body: 'После согласия прежний админ теряет права немедленно и вернуть их сможет только новый.',
    handover_body: 'Права перейдут только после согласия с той стороны. До тех пор ничего не меняется, и предложение можно отозвать.',
    if_quit: 'Если бросите после первого платежа — вернётся {{back}} из внесённых {{paid}}, NFT уйдёт продавцу.',
    legal: 'Подтверждая платёж, вы соглашаетесь с условиями смарт-контракта. Расчёты идут в сети TON, сервис не хранит средства.',
    not_enough: 'На кошельке меньше, чем нужно для взноса.',
    registry_add: 'Добавить в реестр?',
    registry_add_body: 'С этого момента мастер будет принимать такие коллекции в сделки. Проверьте адрес: код берётся из указанного контракта.',
    registry_remove: 'Убрать из реестра?',
    registry_remove_body: 'Новые сделки по этой коллекции создать будет нельзя. Уже идущие продолжатся — мастер до них не дотягивается.',
    set_fee: 'Сменить комиссию?',
    set_ref_key: 'Сменить ключ приглашений?',
    set_ref_key_body: 'Новый ключ получат только новые сделки: уже созданные живут со своим, иначе смена разом обесценила бы все выданные приглашения.',
    transfer_position: 'Передать позицию?',
    transfer_position_body: 'Право на все оставшиеся платежи уйдёт по этому адресу. Отменить это нельзя, а деньги за позицию контракт не держит — рассчитывайтесь до передачи.',
    upfront_title: 'Подтвердите первый взнос',
    withdraw: 'Вывести комиссию?',
    withdraw_body: 'Перевод уйдёт с кошелька мастера на указанный адрес. Если адрес нерабочий, перевод вернётся, а не сгорит.',
  },
  counter: {
    accept: 'Принять условия',
    accepted_hint: 'Продавец передаёт NFT в контракт. Как только это случится, сделка появится в «Моих сделках» — там и вносится первый взнос.',
    accepted_title: 'Условия приняты',
    asked: 'ВЫ ПРОСИЛИ',
    decline: 'Отклонить',
    deferrals: 'Переносов',
    down: 'Взнос',
    down_payment_only: 'Только взнос',
    expires_in: 'Ответить можно ещё',
    grace: 'Льготный период',
    item: 'Какая вещь',
    my_offers: 'Мои предложения',
    none: 'Ответов пока нет',
    payments: 'Платежей',
    refund: 'Компенсация',
    status_accepted: 'Принято',
    status_declined: 'Отклонено',
    status_expired: 'Срок ответа истёк',
    status_open: 'Ждёт вашего решения',
    they_offer: 'ПРЕДЛАГАЮТ',
    total: 'Всего',
    withdraw: 'Отозвать предложение',
  },
  deal: {
    cancel_deal: 'Отменить и забрать NFT',
    deal_total: 'Всего по сделке',
    down_payment: 'Первый взнос',
    service_fee: 'Комиссия сервиса',
  },
  deals: {
    comes_at_closing: 'придёт при закрытии',
    from_upfront: '{{upfront}} со взноса + {{n}} × {{each}}',
    grace_note: 'Это конец льготного периода, а не дата платежа. После него сделка срывается.',
    in_escrow: 'В ЗАЛОГЕ',
    left_payments: 'Осталось платежей: {{n}}',
    none: 'Сделок пока нет',
    paid_of: 'Внесено {{paid}} из {{total}}',
    payment_n: 'Платёж {{n}}',
    payment_of: 'ПЛАТЁЖ {{n}} ИЗ {{total}}',
    running_level: 'СДЕЛКА ИДЁТ · УРОВЕНЬ {{pct}}%',
    schedule_ahead: 'впереди',
    schedule_overdue: 'просрочен',
    schedule_paid: 'оплачен',
    waiting_in_contract: 'ЖДЁТ В КОНТРАКТЕ',
  },
  err: {
    api_disabled: 'Сервис временно недоступен',
    auth_date_future: 'Время открытия из будущего — проверьте часы',
    bad_address: 'Это не похоже на адрес кошелька',
    bad_body: 'Запрос повреждён — попробуйте ещё раз',
    bad_key: 'Ключ кошелька повреждён',
    bad_payments_count: 'Платежей должно быть от 1 до 52',
    bad_proof_payload: 'Подпись просрочена, попробуйте ещё раз',
    bad_terms: 'Такие условия контракт не примет',
    bad_tier: 'Неизвестный уровень возврата',
    bad_user: 'Telegram передал данные, которые мы не поняли',
    connect_wallet: 'Сначала подключите кошелёк',
    counter_not_found: 'Предложение не найдено',
    counter_not_live: 'Предложение больше не действует',
    deadline_too_far: 'Сделка не может длиться дольше 400 суток',
    deal_not_found: 'Сделка не найдена',
    defer_fee_too_high: 'Цена переноса выше четверти платежа',
    domain_not_allowed: 'Подпись собрана на чужом домене',
    forbidden: 'Доступ закрыт',
    init_data_expired: 'Сессия устарела. Откройте приложение заново.',
    internal: 'Сервис не смог обработать запрос. Мы это видим — попробуйте через минуту.',
    key_not_32_bytes: 'Ключ кошелька не той длины',
    key_not_hex: 'Ключ кошелька испорчен',
    key_not_owner: 'Этот ключ не владеет указанным адресом',
    network: 'Сервер не отвечает',
    no_address: 'Не передан адрес кошелька',
    no_auth_date: 'В данных Telegram нет времени открытия',
    no_collection: 'Не выбрана коллекция',
    no_init_data: 'Откройте приложение из Telegram',
    no_signature: 'Telegram не подписал открытие приложения',
    no_such_method: 'Приложение обратилось не туда — обновите его',
    no_user: 'Telegram не передал, кто вы',
    no_user_id: 'Telegram не передал ваш идентификатор',
    not_the_owner: 'Этот оффер адресован владельцу вещи — отвечать на него может только он',
    not_your_counter: 'Это не ваше предложение',
    not_your_request: 'Это не ваш оффер',
    nothing_to_pay: 'Сейчас платить нечего',
    other_item: 'Этот оффер — на другую вещь',
    payload_mismatch: 'Подпись не на ту строку. Начните подтверждение заново.',
    payment_below_min: 'Платёж по графику меньше {{min}} — контракт такой перевод не примет. Поднимите цену или уменьшите число платежей.',
    period_too_short: 'Период короче трёх суток',
    price_zero: 'Цена должна быть больше нуля',
    proof_expired: 'Подпись кошелька просрочена, подпишите заново',
    proof_future: 'Подпись кошелька из будущего — проверьте часы',
    proof_required: 'Нужна подпись кошелька',
    referrals_off: 'Приглашения сейчас выключены',
    request_not_found: 'Оффер не найден',
    request_not_live: 'Оффер больше не действует',
    rounds_exhausted: 'Торг окончен: три круга пройдены',
    schedule_past_deadline: 'График с переносами не помещается в срок сделки',
    self_account: 'Это ваше же приглашение',
    self_wallet: 'Пригласить самого себя нельзя',
    seller_is_buyer: 'На свой оффер отвечать нельзя',
    signature_mismatch: 'Подпись не сходится',
    signature_not_base64: 'Подпись кошелька испорчена',
    signature_not_hex: 'Подпись Telegram испорчена',
    too_many_deferrals: 'Переносов не может быть больше трёх',
    unknown: 'Что-то пошло не так',
    unknown_code: 'Такого кода приглашения нет',
    upfront_below_min: 'Первый взнос меньше {{min}} — контракт такой перевод не примет. Поднимите цену или долю взноса.',
    upfront_out_of_range: 'Первый взнос должен быть от 10% до 50% цены',
    upfront_too_large: 'Первый взнос больше половины цены',
    upfront_too_small: 'Первый взнос меньше 10% цены',
    wallet_disconnected: 'Кошелёк отключился. Подключите его заново — условия лота сохранятся.',
    wallet_not_confirmed: 'Кошелёк не подтверждён. Подтвердите его в профиле — это нужно один раз.',
    wallet_sdk: 'Кошелёк не подтвердил перевод и не сказал почему. Ничего не списано. Если вы закрыли окно кошелька — это оно; если нет, откройте кошелёк, вернитесь и попробуйте ещё раз. Повторится — напишите в поддержку, у нас есть запись об этом сбое.',
    wallet_unreachable: 'Кошелёк не получил запрос: не удалось достучаться до него через TON Connect. Ничего не списано — проверьте связь и попробуйте ещё раз.',
    wallet_wrong_network: 'Кошелёк подключён к другой сети. Переключите его на основную сеть TON.',
  },
  gas: {
    create: 'Создание лота стоит 0,3 GRAM. Это не комиссия: деньги ложатся на сам контракт сделки и живут там как её запас — на возврат NFT при отмене и на выплаты при закрытии. Неизрасходованное вернётся вам, когда сделка закроется.',
    lock: 'Передача NFT в залог — 0,3 GRAM. Из них 0,1 идёт сделке, чтобы она узнала о залоге; остальное тратит сам контракт NFT.',
    pay: 'К платежу приложится 0,02 GRAM на обработку: контракт вычтет ровно их, остальное зачтётся в счёт долга. Это плата сети, а не наша комиссия.',
    refund: 'Остаток газа возвращается стороне продавца при любом исходе: закрытии, срыве и отмене. На контракте остаётся 0,05 GRAM — плата за хранение, пока сделка ещё может понадобиться.',
    simple: 'Сверх суммы платежа контракт возьмёт небольшую надбавку на обработку — её приложит само приложение. Это плата сети, а не наша комиссия: комиссия удерживается из самих платежей.',
    title: 'Сколько GRAM приложится',
  },
  guide: {
    after_down_payment_they: 'После вашего взноса он уже ничего не решает: NFT в контракте, и вернуть её он сможет, только если вы перестанете платить. Тогда ему уйдёт вещь, а вам — часть уплаченного; сколько именно, он назвал заранее, до вашего первого платежа.',
    can_i_late_payment: 'Можно ли опоздать с платежом?',
    can_t_show_telegram: 'Распоряжаться им до последнего платежа нельзя: владелец — контракт, а не кошелёк продавца или покупателя. Именно это и защищает обе стороны.',
    contract_does_transfer_automatically: 'Перевод делает сам контракт, в той же транзакции. Ждать продавца, писать ему и о чём-то просить не нужно.',
    faq: 'Частые вопросы',
    gift_sits_contract_while: 'NFT лежит в контракте, пока идут выплаты',
    gift_stays_contract_whole: 'Первый взнос — сразу, остальное платежами раз в неделю. Всё это время NFT лежит в контракте: у продавца её уже нет, к вам она ещё не пришла.',
    how_works: 'Как это работает',
    last_payment_gift_yours: 'Последний платёж — и NFT ваша',
    moment_they_can_t: 'С этой минуты он не может ни продать её, ни передать кому-то ещё, ни забрать назад. Вещь ждёт вас в контракте, а не в его кошельке.',
    pay_parts: 'Вы платите частями по графику',
    premium_price_paying_over: 'Разница — плата за рассрочку. Продавец отдаёт вещь сейчас, а деньги получает месяцами, и надбавка — его вознаграждение за ожидание. Цену площадки мы показываем рядом: сравнить и купить сразу никто не мешает.',
    seller_puts_gift_into: 'Продавец кладёт NFT в контракт',
    what_if_seller_changes: 'А если продавец передумает?',
    why_price_above_floor: 'Почему цена выше, чем на площадке?',
    yes_grace_period_144: 'Немного — да. У каждой сделки есть льготный период: от двух до восьми суток, тем длиннее, чем меньше возврат при срыве. Пока он идёт, сделка жива и платёж принимается как обычно. А если продавец разрешил переносы, весь график можно сдвинуть на неделю — за отдельную плату.',
  },
  history: {
    cancelled: 'Сделка отменена',
    default_claimed: 'Выплаты сорваны',
    deferral: 'Перенос платежа',
    nft_locked: 'NFT в контракте',
    owed_withdrawn: 'Деньги со сделки забраны',
    payment: 'Платёж',
    position_assigned: 'Позиция передана',
    position_listed: 'Позиция выставлена на продажу',
    position_sold: 'Позиция выкуплена',
  },
  incoming: {
    counter_terms: 'Свои условия',
    offered_total: 'ПРЕДЛАГАЮТ ВСЕГО',
    premium_words: 'Это {{premium}} к флору · {{count}} платежей за {{days}} дней',
  },
  inviter: {
    asks: 'ПРОСИТ',
    came_by_link: 'Вы пришли по приглашению',
    lead: 'Вы пришли по его ссылке. Вот его лоты и офферы — с них и стоит начать.',
    look: 'ПОСМОТРЕТЬ',
    no_offers: 'Лотов сейчас нет.',
    no_requests: 'Офферов сейчас нет.',
    offers: 'Его лоты',
    requests: 'Его офферы',
    title: 'Витрина приглашающего',
    to_market: 'Смотреть всю витрину',
    unknown: 'Ссылка не опознана — покажем общую витрину.',
  },
  market: {
    all_collections: 'Все',
    ask_here: 'Нужного нет? Назовите свою цену',
    can_ask: 'Есть у людей',
    can_ask_hint: 'Эти вещи никто не выставлял на продажу — они просто есть у тех, кто пользуется приложением. Оффер уйдёт владельцу лично, и отвечать он не обязан.',
    deferrals: 'Переносы',
    down: 'ВЗНОС',
    each_shifts_whole_schedule: 'Каждый сдвигает весь график на неделю',
    floor_here: 'купить сразу на площадке',
    floor_short: 'ФЛОР',
    grace_period: 'Льготный период',
    hard_coded_contract_never: 'Зашита в контракт, не больше 5% суммы',
    how_late_may_after: 'Столько можно опаздывать после даты платежа',
    more: 'Ещё',
    no_holdings: 'Здесь пока пусто',
    no_holdings_hint: 'Мы показываем вещи тех, кто пользуется приложением, — по этой коллекции таких пока нет. Назовите свою цену: оффер увидят все держатели коллекции.',
    no_offers: 'Пока никто не выставил рассрочку',
    no_offers_hint: 'Можно не ждать: назовите свою цену оффером, и его увидят держатели коллекции.',
    nothing_found: 'Ничего не нашлось',
    offers: 'NFT',
    on_sale_now: 'НА ПРОДАЖЕ',
    per_week: 'В НЕДЕЛЮ',
    pick_collection: 'Какая коллекция?',
    ready_buy: 'Готовые предложения',
    refund_short: 'КОМПЕНСАЦИЯ',
    search_collection: 'Поиск по названию',
    total_word: 'всего',
    want_installments: 'Хочу в рассрочку',
    weeks_short: 'нед.',
  },
  mine: {
    all_on_sale: 'Ваши подходящие NFT — {{count}} — выставлены на продажу: пока лот на площадке, им владеет её контракт. Снимите с продажи, и они появятся здесь.',
    already_listed: 'Лот уже создан — осталось передать вещь в контракт',
    also_on_sale: 'Ещё {{count}} выставлены на продажу — заложить их можно, только сняв с площадки',
    incoming: 'Входящие',
    lead: 'Ваши NFT из коллекций, которые здесь принимают. Выберите, что выставить в рассрочку: условия назначаете вы.',
    list_it: 'Выставить',
    load_failed: 'Не ответил TON API или наш сервер — какие у вас NFT и какие коллекции здесь принимают, спрашивается у них. Это не значит, что выставлять нечего: попробуйте ещё раз.',
    load_failed_title: 'Список не загрузился',
    my_nfts: 'Мои NFT',
    nothing_hint: 'На кошельке нет NFT из допущенных коллекций. А пока — вот какие офферы приходят другим: на такой можно ответить, когда вещь появится.',
    nothing_title: 'Выставлять пока нечего',
    outgoing: 'Исходящие',
    waiting_buyer: 'В контракте, ждёт покупателя',
  },
  nav: {
    admin: 'Управление',
    board: 'Офферы',
    deals_buyer: 'Сделки · покупатель',
    deals_seller: 'Сделки · продавец',
    offer: 'Лот',
    positions_full: 'Контракты',
  },
  offer: {
    contract_not_wallet_here: 'В контракте, не на кошельке. Почему — за 30 секунд',
    get_back: 'ВЕРНЁТСЯ',
    if_stop_paying: 'Если бросить платить',
    lose: 'ПОТЕРЯЕТЕ',
    pay_today: 'ПЛАТИТЕ СЕЙЧАС',
    payment_schedule: 'График платежей',
    point: 'МОМЕНТ',
    terms: 'Условия',
    upfront_never_back: 'Взнос {{upfront}} не возвращается никогда. Возврат {{refund}}% считается только с платежей после него.',
    upfront_share: 'Первый взнос · {{pct}}% цены · не возвращается',
    where_gift_sits_until: 'Где будет лежать NFT до конца выплат',
  },
  positions: {
    buy: 'Выкупить',
    buy_hint: 'Контракт сам обменяет деньги на право получать оставшиеся платежи — в одной транзакции. NFT остаётся в залоге до конца сделки: сорвётся покупатель — он достанется вам.',
    contact_seller: 'Условия передачи — напрямую с продавцом. Контракт переносит только право на платежи.',
    discipline_late: 'Есть просрочка',
    discipline_ok: 'Платит в срок',
    empty: 'Никто пока не выставил свою позицию',
    in_escrow: 'В залоге',
    in_escrow_label: 'В ЗАЛОГЕ',
    left_to_receive: 'Осталось получить',
    mine: 'Ваша позиция',
    owner: 'Владелец позиции',
    payments_done: 'Платежей сделано',
    price: 'Цена позиции, {{cur}}',
    sort_risk: 'ПО ДИСЦИПЛИНЕ',
    sort_soon: 'БЛИЖАЙШИЙ ПЛАТЁЖ',
    sort_yield: 'ПО ОСТАТКУ',
    subtitle_full: 'Право получать остаток платежей по чужой сделке. Обмен делает контракт: деньги уходят владельцу той же транзакцией, которой позиция переходит к вам. Сорвётся покупатель — NFT из залога достанется вам.',
    title_full: 'Вложиться в чужую сделку',
  },
  profile: {
    balance: 'БАЛАНС · GRAM',
    confirm_first: 'Подтвердите кошелёк, чтобы настраивать уведомления.',
    history: 'История',
    history_empty: 'Операций пока нет',
    language: 'Язык',
    notifications: 'Уведомления',
    notify_grace: 'Конец льготного периода',
    notify_grace_note: 'Самое важное уведомление',
    notify_pay: 'Дата платежа',
    notify_pay_note: 'За трое суток и за сутки до срока',
    notify_req: 'Офферы на мои коллекции',
    notify_req_note: 'Кто и сколько предлагает',
    proof_cancelled: 'Окно кошелька закрыли — подпись не поставлена.',
    proof_timeout: 'Кошелёк не ответил. Попробуйте ещё раз.',
    referral: 'Приглашения',
    referral_note: 'Два процента с цены — тому, кто привёл покупателя',
    show_holdings: 'Показывать мои NFT',
    show_holdings_note: 'Чтобы вам могли предложить рассрочку',
    subscribe: 'Подключить уведомления',
    subscribed: 'Уведомления подключены',
    telegram_only: 'Подписка работает только внутри Telegram.',
    theme: 'Тема',
    theme_dark: 'Тёмная',
    theme_light: 'Светлая',
    wallet_did_not_sign: 'Кошелёк не подписал подтверждение',
    what_we_send: 'Пишем о сроках платежей, ответах на офферы и о том, что деньги вот-вот сгорят.',
    why_proof: 'Подпись доказывает, что кошелёк ваш. Без неё на ваши сделки мог бы подписаться кто угодно. Спрашивается один раз.',
  },
  ref: {
    code: 'Код',
    copied: 'Скопировано',
    copy: 'Скопировать',
    deals: 'Их сделок',
    disabled: 'Приглашения пока выключены.',
    failed: 'Не удалось получить ссылку.',
    go_confirm: 'Подтвердить кошелёк',
    how_1: 'Поделитесь ссылкой. Она ведёт на витрину, и человек сразу видит, что пришёл от вас.',
    how_2: 'Он покупает в рассрочку — в любой коллекции, не только в вашей. Засчитается первая же его покупка.',
    how_3: 'С каждого его платежа ваша доля отделяется от нашей комиссии и копится на сделке. При её закрытии она уходит на ваш кошелёк.',
    how_title: 'Как это работает',
    invited: 'Приглашено',
    invited_by: 'Вы пришли по приглашению. Оно сработает при первой покупке.',
    lead: 'Из нашей комиссии 40% уходит тому, кто привёл покупателя: при сборе в 5% это два процента от цены. Не сверх цены, а из того же сбора — покупателю дороже не становится.',
    link_opens: 'Она открывает витрину, а строкой над ней человек увидит, что пришёл по приглашению, и сможет заглянуть к вам. Приглашение сработает при первой покупке приглашённого — в любой коллекции, не только в вашей.',
    need_wallet: 'Подключите и подтвердите кошелёк — на него и придёт доля.',
    not_confirmed: 'Кошелёк не подтверждён. Откройте профиль и подтвердите его подписью — ссылка привязана к кошельку, и доля приходит именно на него.',
    onchain_note: 'Выплату делает контракт, а не мы: доля отделяется от комиссии в тот же момент, когда она удерживается.',
    open_profile: 'Открыть профиль',
    paid: 'Выплачено, {{cur}}',
    pending: 'Накоплено, {{cur}}',
    pending_note: 'Накопленное уходит при закрытии сделки — одной суммой, вместе с комиссией.',
    self_note: 'Свой второй кошелёк не подойдёт. Приглашение выдаётся аккаунту, а не адресу, и себя пригласить нельзя.',
    share: 'Поделиться',
    title: 'Приглашайте и зарабатывайте',
    visits: 'Переходов',
    visits_note: 'Сколько разных людей открыли приложение по вашей ссылке. Свои переходы не считаются.',
    your_link: 'Ваша ссылка',
  },
  request: {
    answers: 'Ответов',
    down_payment: 'ПЕРВЫЙ ВЗНОС',
    every: 'раз в',
    expired: 'Срок истёк',
    goes_to_owner: 'владельцу этой вещи, лично',
    model: 'всем держателям коллекции',
    my: 'Мои офферы',
    new: 'Новый оффер',
    none: 'Офферов пока нет',
    request_goes: 'Оффер уходит',
    scope_collection: 'Оффер на коллекцию',
    scope_collection_hint: 'Его увидит каждый, у кого есть такая вещь. Ответить может любой — кто первым согласится, с тем и сделка.',
    scope_item: 'Оффер на предмет',
    scope_item_hint: 'Его увидит только владелец этой вещи, и ответить может только он. Отказ закроет оффер.',
    send: 'Отправить оффер',
    sent: 'Оффер отправлен',
    sent_hint: 'О нём узнали держатели этой коллекции — {{count}}. Ответ придёт сюда и в бот.',
    sent_to_owner: 'Оффер ушёл владельцу лично — больше его никто не видит. Ответ придёт сюда и в бот.',
    status_accepted: 'Условия приняты',
    status_cancelled: 'Отозван',
    status_countered: 'Есть ответы',
    status_declined: 'Отказ',
    status_open: 'Ждёт ответа',
    term_weekly_payments: 'СРОК · ПЛАТЕЖИ ПО НЕДЕЛЯМ',
    tier_is_sellers: 'Уровень возврата и переносы назначит продавец — они придут в его ответе.',
    what_seller_sees: 'ЧТО УВИДИТ ПРОДАВЕЦ',
    willing_pay_total: 'ГОТОВ ЗАПЛАТИТЬ ВСЕГО, {{cur}}',
    withdraw: 'Отозвать оффер',
  },
  seller: {
    ask_price: 'Цена позиции, {{cur}}',
    buyer_pays_until: 'Покупатель платит до',
    claim_gift: 'Забрать NFT',
    claim_gift_hint: 'Льготный период кончился. NFT вернётся вам, покупателю уйдёт компенсация по условиям сделки.',
    list: 'Выставить',
    listed_for: 'Выставлена за',
    new_owner_address: 'Адрес нового владельца',
    next_payment: 'Ближайший платёж',
    sell_position: 'Продать позицию',
    sell_position_hint: 'Право на оставшиеся платежи уйдёт тому, кто заплатит названную цену. Обмен делает сам контракт: деньги придут вам той же транзакцией, которой позиция уйдёт покупателю. NFT в залоге остаётся в сделке.',
    transfer_position: 'Передать позицию',
    transfer_position_hint: 'Право на оставшиеся платежи уйдёт по этому адресу. Цену стороны согласуют сами — контракт денег за позицию не держит.',
    unlist: 'Снять с продажи',
  },
  shell: {
    finish: 'Завершить',
    nav_board: 'Моё',
    nav_builder: 'Лот',
    nav_deals: 'Сделки',
    nav_market: 'Витрина',
    nav_profile: 'Профиль',
    sub_admin: 'УПРАВЛЕНИЕ',
    sub_board: 'ВАШИ NFT, СПРОС И ТОРГ',
    sub_builder: 'УСЛОВИЯ РАССРОЧКИ',
    sub_deals: 'ВАШИ ОБЯЗАТЕЛЬСТВА',
    sub_guide: 'КАК ЭТО РАБОТАЕТ',
    sub_inviter: 'лоты и офферы того, кто вас пригласил',
    sub_market: 'NFT В РАССРОЧКУ',
    sub_offer: 'КАРТОЧКА ЛОТА',
    sub_profile: 'КОШЕЛЁК И УВЕДОМЛЕНИЯ',
    sub_referral: 'доля с каждой сделки приглашённого',
    sub_request: 'ОФФЕР НА РАССРОЧКУ',
    unfinished: 'Лот создан, но NFT не передан — покупатели его не видят',
  },
  state: {
    claim: 'Забрать',
    close: 'Закрыть',
    closed_hero: 'NFT у вас',
    closed_note: 'Переведён на ваш кошелёк — с этого момента он ваш целиком.',
    connect_wallet: 'Подключите кошелёк — без него не видно ни сделок, ни офферов.',
    failed_hero: 'Сделка сорвана',
    failed_note: 'Льготный период кончился, NFT вернулся продавцу.',
    forfeited: 'Осталось продавцу',
    left: 'осталось {{x}}',
    paid_total: 'Заплачено всего',
    refunded: 'Вернулось покупателю',
    retry: 'Попробовать ещё раз',
    sent_waiting: 'Отправлено — ждём подтверждения сети',
    sent_waiting_hint: 'Сеть подтверждает перевод около минуты. Экран обновится сам.',
    stuck_hero: 'Перевод не дошёл',
    stuck_note: 'Кошелёк отклонил выплату, деньги остались в контракте. Они ваши — заберите вручную.',
    stuck_rare: 'РЕДКИЙ СЛУЧАЙ',
    waiting_upfront: 'Ждём первый взнос',
    waiting_upfront_hint: 'NFT уже в контракте. Сделка начнётся, когда покупатель внесёт первый взнос.',
  },
  waiting: {
    lead: 'Продавец передал NFT по условиям, которые вы приняли. Сделка начнётся с вашего взноса — до тех пор продавец может забрать NFT назад.',
    pay: 'Внести взнос',
    section: 'Ждут вашего взноса',
    title: 'NFT уже в контракте',
  },
  wallet: {
    connect: 'Подключить',
    copied: 'Скопировано',
    copy: 'Скопировать адрес',
    disconnect: 'Отключить кошелёк',
    title: 'Кошелёк',
  },
};
